import axios from 'axios';
import apiService from '../apiService';

export default async function createTokenRecoverPassword(email = '') {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}loginAdmin/createTokenRecoveryPassword`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        email: email,
      }
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return;
  } catch (error) {
    console.log('Error createTokenRecoverPassword', error);
    throw error;
  }
}
